export default __webpack_public_path__ + "static/media/station-clock-in.c55708e9.png";